import React from 'react';
import { Box, Typography } from '@mui/material';

/** Badge de portada en galerías de edición y detalle compartido. */
export default function ListingImageCoverBadge() {
  return (
    <Box
      sx={{
        position: 'absolute',
        bottom: 6,
        left: 6,
        px: '6px',
        py: '2px',
        borderRadius: '4px',
        bgcolor: 'rgba(0,0,0,0.72)',
        border: '1px solid rgba(255,255,255,0.12)',
      }}
    >
      <Typography
        variant="caption"
        sx={{
          color: '#FFFFFF',
          fontSize: '10px',
          fontWeight: 600,
          letterSpacing: '0.04em',
          textTransform: 'uppercase',
          lineHeight: '14px',
        }}
      >
        Portada
      </Typography>
    </Box>
  );
}
